export const dataAbout = [
    {   id : 0,
        photo : "./image/sachet.jpg",
        heading : "Au profit de la planète.",
        text : "Nous avons conscience de l’impact de nos modes de vie sur l’environnement. C’est la raison pour laquelle nous préférons des sacs papier kraft en faveur du développement durable.",
    },
    {   id : 1,
        photo : "./image/tasse5.jpg",
        heading : "Nous croyons que les rituels de bien-être ne devraient pas être compliqués.",
        text : "C'est pourquoi nous créons des produits entièrement naturels, à base de thé et de plantes, qui se complètent et complètent vos objectifs sans compromettre la commodité, la durabilité ou l'impact.",
    },
    {   id : 2,
        photo : "./image/tasse2.jpg",
        heading : "A votre avantage.",
        text : "Tealea crée tous les produits naturels, à base de thé et de plantes qui vous aident à vivre et à diriger consciemment. Nous voudrions montrer à tous qu'ils ont un pouvoir exceptionnel pour avoir un impact sur eux-mêmes, leurs communautés et leur planète.",
    },

]
export default dataAbout;